import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';

import {
    Snackbar,
    colors
} from '@material-ui/core';

import { AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    sbc: {
        fontSize: '1.2em',
        "& .MuiAlert-icon": {
            fontSize: 50
        }
    },
    sbc2: {
        fontSize: '1.3em'
    },
    sbc3: {
        fontSize: '1.2em',
        "& .MuiAlert-icon": {
            fontSize: 50
        },
        //backgroundColor: colors.pink[900]
        backgroundColor: colors.common.black
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Alerts = ({ message, open, closeAlert, ...rest }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Snackbar open={open}
                autoHideDuration={5000}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={closeAlert}>
                {(message.error) ? (
                    (message.warn)
                        ? (
                            <Alert onClose={closeAlert} severity="warning" className={classes.sbc}>
                                <AlertTitle className={classes.sbc2}>Atencão</AlertTitle>
                                {message.message} {message.detail}
                            </Alert>)
                        : (
                            (message.fatal) ? (
                                <Alert onClose={closeAlert} severity="error" className={classes.sbc3}>
                                    <AlertTitle className={classes.sbc2}>Falha no Sistema</AlertTitle>
                                    {message.message} {message.detail}
                                </Alert>
                            ) : (
                                <Alert onClose={closeAlert} severity="error" className={classes.sbc}>
                                    <AlertTitle className={classes.sbc2}>Erro na Aplicação</AlertTitle>
                                    {message.message} {message.detail}
                                </Alert>
                            )

                        )
                ) : (
                    (message.info) ? (
                        <Alert onClose={closeAlert} severity="info" className={classes.sbc}>
                            <AlertTitle className={classes.sbc2}>Informação</AlertTitle>
                            {message.message} {message.detail}
                        </Alert>
                    ) : (
                        <Alert onClose={closeAlert} severity="success" className={classes.sbc}>
                            <AlertTitle className={classes.sbc2}>Sucesso</AlertTitle>
                            {message.message} {message.detail}
                        </Alert>
                    )
                )}
            </Snackbar>
        </Fragment>
    );
};

export default Alerts;


